import React, { useEffect, useState } from 'react';
import Dropdown from '../Dropdown/index.js';
import classNames from 'classnames';
import { getHours, getMinutes } from '../../../utils/convertTime.js';
import { useTranslation } from 'react-i18next';
import SwitchControl from '../SwitchControl/index.js';
import './style.scss';
import ColumnTitleWithIcon from '../ColumnTitleWithIcon/index.js';

export default function SingleLapseControl({column, value, onPropChange}) {
  const {t} = useTranslation();
  const [isOn, setIsOn] = useState(false);
  const [editItems, setEditItems] = useState({});
  const hours = getHours();
  const minutes = getMinutes();

  useEffect(()=> {
    if(value) {
      setEditItems(value);
      setIsOn(true);
    }
  }, [value]);

  const getEditingValue = (isMinute) => {
    const time = editItems && editItems[isMinute ? "minute" : "hour"];
    const formattedValue = (isMinute ? minutes : hours).find(f=> f.key === time) || {};
    return formattedValue.value;
  }

  const handleOnAdd = () => {
    return new Promise(resolve=> {
      setIsOn(!isOn);
      const data = { hour: 0, minute: 0 };

      resolve();
      setEditItems(value || data);
      if(isOn) {
        onPropChange({ [column.accessor]: null });
      }
    });
  }

  const handleOnChangeLapse = (hour, minute) => {
    const newValue = { ...editItems, ...{
        hour: hour === null ? editItems.hour : hour,
        minute: minute === null ? editItems.minute : minute,
      }}
    setEditItems(newValue);
    onPropChange({ [column.accessor]: newValue });
  }

  return (
    <div className={classNames("singleLapseControl")}>
      <table>
        <thead>
        <tr>
          <th><ColumnTitleWithIcon item={value} column={column} onPropChange={onPropChange} /></th>
        </tr>
        <tr>
          <th className={'switchRow'} width={100}><SwitchControl
            value={isOn}
            onClick={handleOnAdd}
            title={{
              on: t('settings.settings.numericalSettings.YES'),
              off: t('settings.settings.numericalSettings.NO'),
            }}
          /></th>
        </tr>
        </thead>
        <tbody>
        {isOn && (
          <td>
            <div className={classNames("lapseEditItems")}>
              <div className={classNames("lapseEditItem")}>
                <div className={classNames("title")}>
                  {t("settings.orderingmenu.MENU_BUSINESS_SHEDULE_LAPSE_TIME_OPEN_LABEL")}
                </div>
                <div className={classNames("time")}>
                  <Dropdown values={hours} value={getEditingValue()}
                            isRequired={column.isRequired}
                            onSelect={val => handleOnChangeLapse(val.key, null)}
                  />
                  {t("covertTime.TIME_HOUR")}
                  &nbsp;:&nbsp;
                  <Dropdown values={minutes} value={getEditingValue(true)}
                            isRequired={column.isRequired}
                            onSelect={val => handleOnChangeLapse(null, val.key)}
                  />
                  {t("covertTime.TIME_MIN")}
                </div>
              </div>
            </div>
          </td>
        )}
        </tbody>
      </table>
    </div>
  );
}